import React, { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Loader } from "../Components/Loader";

import Dashboard from "../Pages/Dashboard";

import CreateProduct from "../Pages/Product/Create";
import EditProduct from "../Pages/Product/Edit";
import ListProduct from "../Pages/Product/List";
import ProductDetails from "../Pages/Product/View/index";

import CreateCategory from "../Pages/Category/Create";
import ListCategory from "../Pages/Category/List";
import CategoryDetails from "../Pages/Category/View/index";

import CreateCompany from "../Pages/CompanyInfo/Create";
import ListCompany from "../Pages/CompanyInfo/List";
import EditCompany from "../Pages/CompanyInfo/Edit";
import CompanyHistory from "../Pages/CompanyInfo/History";

import CreateDriver from "../Pages/Driver/Create";
import ListDriver from "../Pages/Driver/List";
import DriverHistory from "../Pages/Driver/View";

import ListEmail from "../Pages/Email/List";
import CreateEmail from "../Pages/Email/Create";

import ListNote from "../Pages/Note/List";
import CreateNote from "../Pages/Note/Create";

import DeviceList from "../Pages/Device/List";
import DeviceCreate from "../Pages/Device/Create";
import DeviceEdit from "../Pages/Device/Edit";
import DeviceView from "../Pages/Device/View";

import PlaylistList from "../Pages/Playlist/List";
import PlaylistEdit from "../Pages/Playlist/Edit";

import PlaylistGroupList from "../Pages/PlaylistGroup/List";
import PlaylistGroupCreate from "../Pages/PlaylistGroup/Create";
import PlaylistGroupEdit from "../Pages/PlaylistGroup/Edit";

import MediaLibrary from "../Pages/Media/Library";

/**
 * AppRoutes - Digital Signage CMS routes.
 *
 * Device / Playlist / Media routes are added in Phase 2.
 */
const AppRoutes = () => {
  return (
    <Routes>
      <Route
        element={
          <Suspense fallback={<Loader />}>{/* <Fallback /> */}</Suspense>
        }
        path="/fallback"
      />

      <Route
        path="/"
        element={
          <Suspense fallback={<Loader />}>
            <Navigate to="/dashboard" />
          </Suspense>
        }
      />

      <Route
        path="/dashboard"
        element={
          <Suspense fallback={<Loader />}>
            <Dashboard />
          </Suspense>
        }
      />

      {/* Products */}
      <Route
        path="/product/list"
        element={
          <Suspense fallback={<Loader />}>
            <ListProduct />
          </Suspense>
        }
      />
      <Route
        path="/product/create"
        element={
          <Suspense fallback={<Loader />}>
            <CreateProduct />
          </Suspense>
        }
      />
      <Route
        path="/product/edit/:id"
        element={
          <Suspense fallback={<Loader />}>
            <EditProduct />
          </Suspense>
        }
      />
      <Route
        path="/product-history/:id"
        element={
          <Suspense fallback={<Loader />}>
            <ProductDetails />
          </Suspense>
        }
      />

      {/* Categories */}
      <Route
        path="/category/list"
        element={
          <Suspense fallback={<Loader />}>
            <ListCategory />
          </Suspense>
        }
      />
      <Route
        path="/category/create"
        element={
          <Suspense fallback={<Loader />}>
            <CreateCategory />
          </Suspense>
        }
      />
      <Route
        path="/category-history/:id"
        element={
          <Suspense fallback={<Loader />}>
            <CategoryDetails />
          </Suspense>
        }
      />

      {/* Company */}
      <Route
        path="/company/create"
        element={
          <Suspense fallback={<Loader />}>
            <CreateCompany />
          </Suspense>
        }
      />
      <Route
        path="/company/list"
        element={
          <Suspense fallback={<Loader />}>
            <ListCompany />
          </Suspense>
        }
      />
      <Route
        path="/company-history/:id"
        element={
          <Suspense fallback={<Loader />}>
            <EditCompany />
          </Suspense>
        }
      />
      <Route
        path="/companyInfo-history/:id"
        element={
          <Suspense fallback={<Loader />}>
            <CompanyHistory />
          </Suspense>
        }
      />

      {/* Users (Driver module repurposed as Users) */}
      <Route
        path="/team/create"
        element={
          <Suspense fallback={<Loader />}>
            <CreateDriver />
          </Suspense>
        }
      />
      <Route
        path="/team/list"
        element={
          <Suspense fallback={<Loader />}>
            <ListDriver />
          </Suspense>
        }
      />
      <Route
        path="/team-history/:id"
        element={
          <Suspense fallback={<Loader />}>
            <DriverHistory />
          </Suspense>
        }
      />

      {/* Settings - templates */}
      <Route
        path="/email/list"
        element={
          <Suspense fallback={<Loader />}>
            <ListEmail />
          </Suspense>
        }
      />
      <Route
        path="/email/create"
        element={
          <Suspense fallback={<Loader />}>
            <CreateEmail />
          </Suspense>
        }
      />
      <Route
        path="/note/list"
        element={
          <Suspense fallback={<Loader />}>
            <ListNote />
          </Suspense>
        }
      />
      <Route
        path="/note/create"
        element={
          <Suspense fallback={<Loader />}>
            <CreateNote />
          </Suspense>
        }
      />

      {/* Devices */}
      <Route
        path="/device/list"
        element={
          <Suspense fallback={<Loader />}>
            <DeviceList />
          </Suspense>
        }
      />
      <Route
        path="/device/create"
        element={
          <Suspense fallback={<Loader />}>
            <DeviceCreate />
          </Suspense>
        }
      />
      <Route
        path="/device/edit/:id"
        element={
          <Suspense fallback={<Loader />}>
            <DeviceEdit />
          </Suspense>
        }
      />
      <Route
        path="/device/view/:id"
        element={
          <Suspense fallback={<Loader />}>
            <DeviceView />
          </Suspense>
        }
      />

      {/* Playlists */}
      <Route
        path="/playlist/list"
        element={
          <Suspense fallback={<Loader />}>
            <PlaylistList />
          </Suspense>
        }
      />
      <Route
        path="/playlist/edit/:id"
        element={
          <Suspense fallback={<Loader />}>
            <PlaylistEdit />
          </Suspense>
        }
      />

      {/* Playlist Groups */}
      <Route
        path="/playlist-groups/list"
        element={
          <Suspense fallback={<Loader />}>
            <PlaylistGroupList />
          </Suspense>
        }
      />
      <Route
        path="/playlist-groups/create"
        element={
          <Suspense fallback={<Loader />}>
            <PlaylistGroupCreate />
          </Suspense>
        }
      />
      <Route
        path="/playlist-groups/edit/:id"
        element={
          <Suspense fallback={<Loader />}>
            <PlaylistGroupEdit />
          </Suspense>
        }
      />

      {/* Media Library */}
      <Route
        path="/media/library"
        element={
          <Suspense fallback={<Loader />}>
            <MediaLibrary />
          </Suspense>
        }
      />

      <Route element={<Navigate replace to="/dashboard" />} path="*" />
    </Routes>
  );
};

export default AppRoutes;
